type UpdateSearch<S extends Record<string, unknown>> = (next: {
  search: (prev: S) => S
}) => Promise<void> | void

export function useSearchFilter<S extends Record<string, unknown>>(navigate: UpdateSearch<S>) {
  return <K extends keyof S>(key: K, value: string | undefined) => {
    void navigate({
      search: (prev) => {
        const next = { ...prev }
        if (value) {
          next[key] = value as S[K]
        } else {
          delete next[key]
        }
        return next
      },
    })
  }
}
